import { z } from "zod";

import { dormantSurfaceListSchema } from "@/lib/dormant-season/types";

const booleanString = z
  .enum(["true", "false", "True", "False"])
  .transform((value) => value.toLowerCase() === "true");

const publicEnvSchema = z.object({
  NEXT_PUBLIC_SITE_URL: z.string().min(1),
  NEXT_PUBLIC_GOOGLE_CLIENT_ID: z.string().min(1),

  NEXT_PUBLIC_BASE_PATH: z.string().optional(),
  NEXT_PUBLIC_POSTHOG_KEY: z.string().optional(),
  NEXT_PUBLIC_POSTHOG_HOST: z.string().optional(),
  NEXT_PUBLIC_GOOGLE_MAPS_API_KEY: z.string().optional(),
  NEXT_PUBLIC_INTERCOM_ID: z.string().optional(),
  NEXT_PUBLIC_SENTRY_NEXT_FE_DSN: z.string().optional(),
  NEXT_PUBLIC_PENDO_KEY: z.string().optional(),
  NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID: z.string().optional(),
  NEXT_PUBLIC_BETA_SECRET: z.string().optional(),
  NEXT_PUBLIC_ENABLE_EXPRESS_INTEREST: booleanString.optional(),
  NEXT_PUBLIC_DORMANT_SEASON: dormantSurfaceListSchema,
  NEXT_PUBLIC_RESUME_PARSING_GATE: booleanString.optional(),
  NEXT_PUBLIC_LEAFLET_BASEMAPS_KEY: z.string().optional(),
});

export type PublicEnv = z.infer<typeof publicEnvSchema>;

export const publicEnv: PublicEnv = publicEnvSchema.parse({
  NEXT_PUBLIC_SITE_URL: process.env.NEXT_PUBLIC_SITE_URL,
  NEXT_PUBLIC_BASE_PATH: process.env.NEXT_PUBLIC_BASE_PATH,
  NEXT_PUBLIC_GOOGLE_CLIENT_ID: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID,

  NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
  NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  NEXT_PUBLIC_GOOGLE_MAPS_API_KEY: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
  NEXT_PUBLIC_INTERCOM_ID: process.env.NEXT_PUBLIC_INTERCOM_ID,
  NEXT_PUBLIC_SENTRY_NEXT_FE_DSN: process.env.NEXT_PUBLIC_SENTRY_NEXT_FE_DSN,
  NEXT_PUBLIC_PENDO_KEY: process.env.NEXT_PUBLIC_PENDO_KEY,
  NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID:
    process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID,
  NEXT_PUBLIC_BETA_SECRET: process.env.NEXT_PUBLIC_BETA_SECRET,
  NEXT_PUBLIC_ENABLE_EXPRESS_INTEREST:
    process.env.NEXT_PUBLIC_ENABLE_EXPRESS_INTEREST,
  NEXT_PUBLIC_DORMANT_SEASON: process.env.NEXT_PUBLIC_DORMANT_SEASON,
  NEXT_PUBLIC_RESUME_PARSING_GATE: process.env.NEXT_PUBLIC_RESUME_PARSING_GATE,
  NEXT_PUBLIC_LEAFLET_BASEMAPS_KEY:
    process.env.NEXT_PUBLIC_LEAFLET_BASEMAPS_KEY,
});
